import CustomSelect from './customSelect'
import noUiSlider from 'nouislider/distribute/nouislider.min'
import wNumb from 'wnumb'
import {phoneMask} from './phone-mask.js'
import {forEach} from './helpers.js'
import {counter} from "../components/counter/counter";
import Bouncer from "./bouncer";
import { validateConfig } from "./validateConfig";
import {datepicker} from "../components/datepicker/datepicker";
import {File} from "../components/file/File";

forEach(document.querySelectorAll('.header-datepicker'), el => {
  datepicker(el)
});

forEach(document.querySelectorAll('.b-counter'), item => {
  counter(item);
});

function showPass(input) {
  if(!input.value) return;
  if (input.type === "password") {
    input.type = "text";
  } else {
    input.type = "password";
  }
}

forEach(document.querySelectorAll('input[type="password"]'), input => {
  const icon = input.nextElementSibling;
  if (!icon.classList.contains('pass')) return;
  let repeatPassEl;
  if (input.id) {
    repeatPassEl = document.querySelector(`[data-bouncer-match="#${input.id}"]`)
  } else if(input.getAttribute('data-bouncer-match')) {
    repeatPassEl = document.querySelector(input.getAttribute('data-bouncer-match'));
  }
  input.setAttribute('data-type', 'password');
  icon.addEventListener('click', () => {
    showPass(input);
    if (repeatPassEl) {
      showPass(repeatPassEl);
    }
  });
});

forEach(document.querySelectorAll('.file-wrapper'), item => new File(item).init());

new Bouncer('#form-register-test', validateConfig);
// (new Bouncer()).validate(document.forms['form-register-test'].elements['EMAIL'], validateConfig);

new Bouncer('#form-login', validateConfig);
new Bouncer('#form-fast-order', validateConfig);
new Bouncer('#form-register', validateConfig);
new Bouncer('#form-recover', validateConfig);
new Bouncer('#form-new-password', validateConfig);



document.addEventListener('bouncerFormValid', function (event) {
  const form = event.target;
  if (!form.classList.contains('cart-order')) {
    form.classList.add('is-loading');
  }
});

// onlyNumber(document.querySelectorAll('[data-field="number"]'));
// maxValue(document.querySelectorAll('input[type="number"]'));
CustomSelect(document.querySelectorAll('.select'));

forEach(document.querySelectorAll('[data-field="phone"]'), el => {
  phoneMask(el)
});

forEach(document.querySelectorAll('[data-toggle="checkbox-toggle"]'), checkbox => {
  // console.log(checkbox.dataset.target);
  const contents = document.querySelectorAll(checkbox.dataset.target);
  // console.log(contents);
  forEach(contents, content => {
    content.style.setProperty('--max-height', content.scrollHeight + 'px');
  });
  checkbox.addEventListener('change', () => {
    forEach(contents, content => {
      content.setAttribute('aria-expanded', checkbox.dataset.swap ? !checkbox.checked : checkbox.checked);
    });
  });
});

forEach(document.querySelectorAll('[data-toggle="radiobox-toggle"]'), radiobox => {
  const contents = document.querySelectorAll(radiobox.dataset.target);
  // console.log(document.querySelectorAll(radiobox.name));
  forEach(contents, content => {
    content.style.setProperty('--max-height', content.scrollHeight + 'px');
  });
  radiobox.addEventListener('change', () => {
    forEach(document.querySelectorAll(`[name=${radiobox.name}]`), radio => {
      const contents = document.querySelectorAll(radio.dataset.target);
      forEach(contents, content => {
        content.setAttribute('aria-expanded', radio.checked);
      });
    });
  });
});

forEach(document.querySelectorAll('.form-send-attachments'), el => {
  const buttons = el.querySelectorAll('.form-send-attachments__button');
  forEach(buttons, button => {
    button.addEventListener('click', () => {
      button.classList.toggle('active')
    })
  });

});

forEach(document.querySelectorAll('[data-field="uiSlider"]'), el => {
  const control0 = el.parentElement.querySelector('.control0');
  const control1 = el.parentElement.querySelector('.control1');
  const controls = [control0, control1];
  control0.textContent = el.dataset.startLow;
  control1.textContent = el.dataset.startHigh;
  noUiSlider.create(el, {
    start: [+el.dataset.startLow, +el.dataset.startHigh],
    connect: true,
    format: wNumb({
      decimals: 0
    }),
    range: {
      'min': +el.dataset.low,
      'max': +el.dataset.high
    }
  });
  el.noUiSlider.on('update', function (values, handle) {
    controls[handle].textContent = values[handle];
  });
});

forEach(document.querySelectorAll('.group-inputs'), container => {
  const inputs = container.querySelectorAll('input[type="text"]');
  forEach(inputs, input => {
    input.addEventListener('keyup', e => {
      const next = input.nextElementSibling;
      const key = e.which || e.keyCode;
      if(key === 37) return;
      if(key === 39) return;
      if (input.value.length > 0) {input.value = input.value.split("").pop()}
      if(key === 8) return;
      if(next) {next.focus()}
    })
  });

});
